import React, { useEffect, useState } from "react";
import AllProductsComponent from "../../Components/AllProductsComponent/AllProductsComponent";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import BannerPage from "../../Components/Banner/BannerPage";
import ProductArea from "../../Components/ProductArea/ProductArea";
import OtherAffiliatePartner from "../../Components/OtherAffiliatePartner/OtherAffiliatePartner";
import TopWinners from "../../Components/TopWinners/TopWinners";
import { Apiurl, GetLocalStorageParsed, parseData, stringifyData } from "../utils/page";
import axios from "axios";
import Loader from "../../Components/Loader/Loader";

const AllProducts = () => {
      const FetchToken = GetLocalStorageParsed("AuthToken");
      const[loading,setLoading]=useState("")
  const [pageNumberAffiliate, setPageNumberAffiliate] = useState(0);
  const [totalRecordAffiliate, setTotalRecordAffiliate] = useState();
  const [allProductsData, setAllProductsData] = useState([]);
  const [indexForProduct, setIndexForProducts] = useState(0);
  const [smallBannerData, setSmallBannerData] = useState();
  const [filteredProductData, setfilteredProductData] = useState();
  const [favouriteData, setFavouriteData] = useState();
  const [apiCallingOnLogin, setApiCallingOnLogin] = useState(false);







    
  const [loginToken, setLoginToken] = useState(FetchToken || null);
  const [bannerIdData, setBannerIdData] = useState();
  useEffect(() => {
    window.scrollTo(0, 0);
    setPageNumberAffiliate(0);
  }, []);

  const [bannerData, setBannerData] = useState([]);
   const getBanners = () => {
      const option = {
        method: "GET",
        headers: {
          accept: "*/*",
          Authorization: `Bearer ${loginToken || " "}`,
        },
        url: `${Apiurl()}/api/Product/Banner`,
      };
  
      axios(option)
        .then(async (e) => {
          let banners = parseData(e?.data?.result) || [];
  
          setBannerData(banners);
          setBannerIdData(banners[0]?.Id || null);
        })
        .catch((error) => {
          console.error("Error fetching banners:", error);
        });
    };
    // const handleGetFavourite = () => {
    //     const option = {
    //       method: "GET",
    //       headers: {
    //         accept: "*/*",
    //         Authorization: `Bearer ${loginToken}`,
    //       },
    //       url: `${Apiurl()}/api/Customer/GetSavedBanners`,
    //     };
    //     axios(option)
    //       .then((e) => {
    //         setFavouriteData(parseData(e?.data?.result));
    //       })
    //       .catch((error) => {});
    //   };
      

      useEffect(() => {
        setLoading("homePage");
    
        getBanners();
        // handleGetFavourite()
      }, []);
      const getAllProducts = (e, pagination) => {
        if (pagination === "pag") {
          setPageNumberAffiliate(e);
        }
        const data = {
          id: bannerIdData,
        };
        data.pageNumber = pagination === "pag" ? e + 1 : 1 || 1;
        data.pageSize = 16;
        const options = {
          method: "POST",
          headers: {
            accept: "*/*",
            "Content-Type": "application/json",
            Authorization: `Bearer ${loginToken || " "}`,
          },
          data: JSON.stringify(data),
          url: `${Apiurl()}/api/Product/GetAll`,
        };
        axios(options)
          .then((e) => {
            const parsedData = parseData(e?.data?.result);
            setTotalRecordAffiliate(e?.data?.totalRecords);
    
            const sortedData = parsedData?.sort((a, b) => {
              const dateA = new Date(a.ToPushlishDate);
              const dateB = new Date(b.ToPushlishDate);
              return dateA - dateB; // Ascending order
            });
    
            setAllProductsData(sortedData);
            setLoading("");
          })
          .catch((error) => {});
      };
  
 
  // get product by banner id
  const getProductsByBannerId = () => {
    const data = {
      id: bannerIdData,
    };
    const option = {
      method: "POST",
      headers: {
        // 'accept': '*/*',
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken || " "}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Product/GetAllProductsByBanner`,
    };
    axios(option)
      .then((e) => {
        setIndexForProducts(0);
        const data = parseData(e?.data?.result);

        const sortByDate = data?.sort(
          (a, b) => new Date(a.ToPushlishDate) - new Date(b.ToPushlishDate)
        );

        setSmallBannerData(sortByDate);
      })
      .catch((error) => {});
  };
  const getRewardOnBanner = (item) => {
    const data = {
      id: bannerIdData,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Customer/DeductionPerViewBanner`,
    };
    axios(option)
      .then((e) => {})
      .catch((error) => {});
  };

  useEffect(() => {
    if (bannerIdData) {
      getProductsByBannerId();
      getAllProducts();
    }
  }, [bannerIdData]);
  useEffect(() => {
    if (loginToken && bannerIdData) {
      getRewardOnBanner();
    }
  }, [loginToken, bannerIdData]);

  const onNextClick = () => {
    const nextIndex =
      indexForProduct + 1 >= filteredProductData.length
        ? 0
        : indexForProduct + 1;
    setIndexForProducts(nextIndex);
  };
  // add buy products
  const handleBuyProduct = (item) => {
    setLoading("buy");
    const data = {
      productId: item?.Id,
    };
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${loginToken}`,
      },
      data: stringifyData(data),
      url: `${Apiurl()}/api/Order/Add`,
    };
    axios(option)
      .then((e) => {
        setLoading("");

        onNextClick();
      })
      .catch((error) => {
        setLoading("");
      });
  };

  // add to favourites
  // const handleAddtoFavourite = () => {
  //   if (loginToken) {
  //     setLoading("fav");
  //     const data = {
  //       id: bannerIdData,
  //     };
  //     const option = {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${loginToken}`,
  //       },
  //       data: stringifyData(data),
  //       url: `${Apiurl()}/api/Customer/SaveInterstedBanner`,
  //     };
  //     axios(option)
  //       .then((e) => {
  //         setLoading("");
  //         if (e?.data?.status === "OK") {
  //           toast.success(e?.data?.message);
  //         }
  //         if (e?.data?.status === "BadRequest") {
  //           toast.error(e?.data?.message);
  //         }
  //         handleGetFavourite();
  //       })
  //       .catch((error) => {
  //         setLoading("");
  //       });
  //   } else {
  //     handleShow();
  //   }
  // };
  // delete favourite
  // const hanleDeleteFavourite = (item) => {
  //   setLoading("fav");
  //   const data = {
  //     id: item === "topButt" ? bannerIdData : item?.BannerId,
  //   };
  //   const option = {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer ${loginToken}`,
  //     },
  //     data: stringifyData(data),
  //     url: `${Apiurl()}/api/Customer/RemoveSavedBanner`,
  //   };
  //   axios(option)
  //     .then((e) => {
  //       setLoading("");
  //       if (e?.data?.status === "OK") {
  //         toast.success(e?.data?.message);
  //       }
  //       if (e?.data?.status === "BadRequest") {
  //         toast.error(e?.data?.message);
  //       }
  //       handleGetFavourite();
  //     })
  //     .catch((error) => {});
  // };
  // get reward on banner view
  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
    >
       {loading === "mainLoader" || loading === "homePage"  ? (
        <div className="loading-container">
          <Loader />
        </div>
      ) : null}
      <Header 
          setLoginToken={setLoginToken}
          setLoading={setLoading }
          setApiCallingOnLogin={setApiCallingOnLogin}
          apiCallingOnLogin={apiCallingOnLogin}
      
      />
      <BannerPage
          bannerData={bannerData}
          setBannerIdData={setBannerIdData}
          loading={loading}
        />
        <ProductArea
          loading={loading}
          filteredProductData={filteredProductData}
          setIndexForProducts={setIndexForProducts}
          indexForProduct={indexForProduct}
          handleBuyProduct={handleBuyProduct}
          onNextClick={onNextClick}
          smallBannerData={smallBannerData}
        //   handleAddtoFavourite={handleAddtoFavourite}
          favouriteData={favouriteData}
          bannerIdData={bannerIdData}
        //   hanleDeleteFavourite={hanleDeleteFavourite}
          loginToken={loginToken}
        />
        <OtherAffiliatePartner
          allProductsData={allProductsData}
          totalRecordAffiliate={totalRecordAffiliate}
          getAllProducts={getAllProducts}
          pageNumberAffiliate={pageNumberAffiliate}
        />
        <TopWinners />
      {/* <AllProductsComponent /> */}
      <Footer />
    </div>
  );
};

export default AllProducts;
